import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeading.module.scss';

export default function PageHeading({
  title,
  description = null,
  children = null,
}) {
  return (
    <div className={styles.heading}>
      <h1 className="display-heading-03">{title}</h1>
      {description && <p className={styles.heading__description}>{description}</p>}
      {children && <div className={styles.heading__description}>{children}</div>}
    </div>
  );
}

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node || PropTypes.string,
  children: PropTypes.node,
};
